var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center padding-tb-lg margin-top"},[_c('router-link',{staticStyle:{"color":"#bfbfc3"},attrs:{"to":"/featnet"}},[_vm._v("多陪提供技术支持")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }